module.exports = __webpack_public_path__ + "static/media/bgs1.7e46d10d.jpg";